const PAID_TIERS = ['pro', 'trade', 'business'];
const GLOBAL_PRO_TIERS = ['trade', 'business'];

function clean(value) {
  return String(value || '').trim().toLowerCase();
}

function councilMatches(allowed, council) {
  const allowedValue = clean(allowed);
  const councilValue = clean(council);
  if (!allowedValue || !councilValue) return false;
  return allowedValue === councilValue ||
    allowedValue.includes(councilValue) ||
    councilValue.includes(allowedValue);
}

export function isPaidIntelligenceTier(tier) {
  return PAID_TIERS.includes(clean(tier));
}

export function canAccessProCouncil({ tier, proCouncils = [], council } = {}) {
  const cleanTier = clean(tier);
  if (!isPaidIntelligenceTier(cleanTier)) return false;
  if (GLOBAL_PRO_TIERS.includes(cleanTier)) return true;

  const allowedCouncils = Array.isArray(proCouncils) ? proCouncils.filter(Boolean) : [];
  if (allowedCouncils.length === 0) return true;
  return allowedCouncils.some(allowed => councilMatches(allowed, council));
}

export function filterProAccessibleDAs(das, access) {
  return (Array.isArray(das) ? das : []).filter(da =>
    canAccessProCouncil({ ...access, council: da?.council })
  );
}
